<section class="main">
    <mat-tab-group>
        <mat-tab label="Add Card">
            <div class="row mt-4">
                <div class="col" *ngFor="let item of cardtype_arr">
                    <input (change)="radioChange($event)" type="radio" checked id="{{ item.id }}" name="name"
                        value="{{ item.id }}" />
                    <label class="ms-1" for="{{ item.id }}">{{ item.name }}</label>
                </div>
                <div class="col">
                    <input (change)="radioChange($event)" type="radio" checked id="RFID" name="name" value="RFID" />
                    <label class="ms-1" for="RFID">RFID</label>
                </div>
            </div>
            <div class="mt-2" *ngIf="cardType == 'RFID'" >
                <form [formGroup]="RfidForm">
                    <div class="col-md-12">
                        <label>Vechicle Number </label>
                        <div class="row">
                            <div class="col-md-6">
                                <input formControlName="number" type="text" class="form-control" />
                            </div>
                            <div class="col-md-2">
                                <input formControlName="charOne" type="text" class="form-control" />
                            </div>
                            <div class="col-md-2">
                                <input formControlName="charTow" type="text" class="form-control" />
                            </div>
                            <div class="col-md-2">
                                <input formControlName="charThree" type="text" class="form-control" />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mt-3">
                        <label>Driving License Front Face</label>
                        <input (change)="onFileChange($event, 'front')" formControlName="front" type="file" />
                    </div>
                    <div class="col-md-12 mt-3">
                        <label>Driving License Back Face</label>
                        <input (change)="onFileChange($event, 'back')" formControlName="back" type="file" />
                    </div>
                    <div class="col-md-12 mt-3">
                        <label>Car Tag </label>
                        <input formControlName="card_id" type="text" class="form-control" />
                    </div>
                    <div class="col-md-12 mt-3">
                        <label>Serial Number </label>
                        <input formControlName="serial_number" type="text" class="form-control" />
                    </div>
                </form>
            </div>

            <div class="mt-3" *ngIf="cardType != 'RFID'">
                <label>
                    Card ID
                </label>
                <input type="text" [(ngModel)]="cardId" class="form-control" />
            </div>
            <div class="mt-3">
                <button class="btn" (click)="addCard()">Create</button>
            </div>
        </mat-tab>

        <mat-tab label="Cards List">
            <div class="mt-4 cardContianer">
                <div class="mb-3 card" *ngFor="let item of cards_arr">
                    <div>
                        <h4>{{ item.card_id }}</h4>
                        <p>{{ item.type_name }}</p>
                    </div>
                    <img (click)="deletCard(item)" src="assets/images/delete.png" />
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</section>